import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { colors } from '../../../theme/tokens';

export interface GaugeChartProps {
  value: number; // 0-100
  label?: string;
  color?: string;
  height?: number;
}

const DARK = colors.textPrimary;

export default function GaugeChart({
  value,
  label,
  color = colors.brandStrong,
  height = 220,
}: GaugeChartProps) {
  const clamped = Math.max(0, Math.min(100, value));
  const data = {
    datasets: [
      {
        data: [clamped, 100 - clamped],
        backgroundColor: [color, colors.bgRaised],
        borderWidth: 0,
      },
    ],
  };
  const options: any = {
    responsive: true,
    maintainAspectRatio: true,
    circumference: Math.PI,
    rotation: Math.PI,
    cutoutPercentage: 75,
    legend: { display: false },
    tooltips: { enabled: false },
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <Doughnut data={data} options={options} height={height} />
      <div
        style={{
          fontSize: 28,
          fontWeight: 800,
          color: DARK,
          marginTop: -height / 3,
        }}
      >
        {clamped}%
      </div>
      {label && (
        <div style={{ fontSize: 11, color: colors.textFaint, fontWeight: 600 }}>
          {label}
        </div>
      )}
    </div>
  );
}
